<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900px">
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Subject: {{ emailDetails ? emailDetails.subject : "" }}
          </v-card-title>
          <v-card-subtitle>
            <v-row>
              <v-col
                ><h3>
                  From: {{ emailDetails ? emailDetails.from : "" }}
                </h3></v-col
              >
              <v-col
                ><h3>To: {{ emailDetails ? emailDetails.to : "" }}</h3></v-col
              >
            </v-row>
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text>
            <div v-html="body"></div>
          </v-card-text>
        </v-card>
        <v-card class="mt-4">
          <v-card-title>Recipients</v-card-title>
          <v-card-text>
            <v-data-table :headers="recipientsHeaders" :items="recipients">
              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status == 'DELIVERED'">
                  <v-chip color="primary" small outlined>
                    {{ item.status }}
                  </v-chip>
                </span>
                <span v-else-if="item.status == 'OPENED'">
                  <v-chip color="green lighten-2" small outlined>
                    {{ item.status }}
                  </v-chip>
                </span>
                <span v-else-if="item.status == 'CLICKED'">
                  <v-chip color="success" small outlined>
                    {{ item.status }}
                  </v-chip>
                </span>
                <span v-else>
                  <v-chip color="error" small outlined>
                    {{ item.status }}
                  </v-chip>
                </span>
              </template>
              <template v-slot:[`item.lastDeliveredDisplay`]="{ item }">
                <span v-if="item.lastDeliveredDisplay">
                  <v-icon color="success" small>mdi-check</v-icon>
                  {{ item.lastDeliveredDisplay }}
                </span>
                <span v-else>
                  <v-icon color="error" small>mdi-close</v-icon>
                  {{ item.lastDeliveredDisplay }}
                </span>
              </template>
              <template v-slot:[`item.lastOpenedDisplay`]="{ item }">
                <span v-if="item.lastOpenedDisplay">
                  <v-icon color="success" small>mdi-check</v-icon>
                  {{ item.lastOpenedDisplay }}
                </span>
                <span v-else>
                  <v-icon color="error" small>mdi-close</v-icon>
                  {{ item.lastOpenedDisplay }}
                </span>
              </template>
              <template v-slot:[`item.lastClickedDisplay`]="{ item }">
                <span v-if="item.lastClickedDisplay">
                  <v-icon color="success" small>mdi-check</v-icon>
                  {{ item.lastClickedDisplay }}
                </span>
                <span v-else>
                  <v-icon color="error" small>mdi-close</v-icon>
                  {{ item.lastClickedDisplay }}
                </span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ emailDetails }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "./BasicDialog.vue";
const EMAIL_DETAILS = gql`
  query emailDetails($id: ID!) {
    emailDetails(id: $id) {
      id
      from
      to
      subject
      body
      recipients {
        recipient
        status
        lastDeliveredDisplay
        lastClickedDisplay
        lastOpenedDisplay
      }
    }
  }
`;
export default {
  name: "email-details-dialog",
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      id: this.value && this.value.id ? this.value.id : "",
      recipientsHeaders: [
        { text: "Recipient", value: "recipient" },
        { text: "Status", value: "status" },
        { text: "Delivered", value: "lastDeliveredDisplay" },
        { text: "Opened", value: "lastOpenedDisplay" },
        { text: "Clicked", value: "lastClickedDisplay" },
      ],
    };
  },

  computed: {
    body() {
      return this.emailDetails ? this.emailDetails.body : "<b>Email Body</b>";
    },
    recipients() {
      return this.emailDetails ? this.emailDetails.recipients : [];
    },
  },

  watch: {
    value(newVal) {
      this.id = newVal && newVal.id ? newVal.id : "";
    },
  },

  methods: {
    escapeHtml(unsafe) {
      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
  },

  apollo: {
    emailDetails: {
      query: EMAIL_DETAILS,
      variables() {
        return {
          id: this.id,
        };
      },
      skip() {
        return this.id == "";
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/EmailDetailsDialog.vue